<template>
  <div class="step-questions-actions">
    <button v-on="$listeners" class="next-question" :disabled="loading">
      <template v-if="!loading">
        Next question
        <span v-if="useChevronIcon" class="chevron-right" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            width="16"
            height="16"
          >
            <path d="M9 6l6 6-6 6" />
          </svg>
        </span>
        <img
          v-else
          class="share-icons"
          :src="arrowIconSrc"
          alt=""
          width="26"
          height="16"
          style="width: 26px; height: 16px"
        />
      </template>
      <img
        v-else
        loading="eager"
        src="https://www.medexpress.co.uk/images/medexpress-resources/svg/dot-loader.svg"
        alt="Loading"
        width="30"
        height="30"
      />
    </button>
  </div>
</template>

<script lang="ts">
export default {
  name: "NextQuestionButton",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  computed: {
    useChevronIcon(): boolean {
      return this.theme === "medexpress" && process.env.REGION === "uk";
    },
    arrowIconSrc(): string {
      const color = this.theme === "levity" ? "black" : "white";
      return `/resources/img/icons/${color}_right_arrow.svg`;
    },
  },
};
</script>

<style scoped>
.next-question .chevron-right {
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
  vertical-align: middle;
}

.next-question .chevron-right svg {
  display: block;
}

.next-question:disabled {
  min-height: 70px;
}
</style>
